import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { fetchPasswordStatus, TPasswordResetStatus } from "@/data/session";
import { useToasts } from "@/views/components/Toast/useToasts";

export function usePasswordStatus(token: string): TPasswordResetStatus | null {
  const [passwordStatus, setPasswordStatus] = useState<TPasswordResetStatus | null>(null);
  const { addToast } = useToasts();
  const { t } = useTranslation("common");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchPasswordStatus(token);
        setPasswordStatus(data.status);
      } catch (error) {
        addToast({ text: t("common:VALIDATION_MESSAGES.GENERAL"), type: "warning" });
      }
    };

    fetchData();
  }, [token, addToast]);

  return passwordStatus;
}
